module.exports = __webpack_public_path__ + "img/07-settings.d966e24e.svg";